const DAY = 86400000;
const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;
const st = r => String(r?.status || r?.background?.status || "").toUpperCase();

const sequenceListFindings = (rows = [], { now = Date.now(), actions = {} } = {}) => {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return [];
  const out = [];
  const active = list.filter(r => st(r) === "ACTIVE");
  const empty = active.filter(r => !(r.contactsAdded > 0));
  if (empty.length) {
    out.push({
      tone: "warn",
      label: "Active with nobody in it",
      text: `${empty.map(r => r.name).slice(0, 3).join(", ")} ${empty.length === 1 ? "is" : "are"} live with no contacts. Add some or pause.`,
      actions: actions.open ? [{ label: "Open", run: () => actions.open(empty[0]) }] : []
    });
  }
  const paused = list.filter(r => st(r) === "PAUSED");
  if (paused.length) {
    out.push({
      tone: "warn",
      label: plural(paused.length, "paused sequence"),
      text: "Paused means nothing sends. Resume or stop them.",
      actions: actions.resume ? [{ label: `Resume ${paused[0].name}`, run: () => actions.resume(paused[0]) }] : []
    });
  }
  const stale = list.filter(r => st(r) === "DRAFT" && r.createTs && now - r.createTs > 7 * DAY);
  if (stale.length) {
    out.push({
      tone: "neutral",
      label: plural(stale.length, "draft") + " going stale",
      text: "Older than a week and never activated. Finish or delete.",
      actions: actions.open ? [{ label: "Open", run: () => actions.open(stale[0]) }] : []
    });
  }
  if (!active.length) {
    out.push({
      tone: "bad",
      label: "Nothing is sending",
      text: "No active sequence. Want help building one?",
      actions: actions.build ? [{ label: "Help me build one", run: actions.build }] : []
    });
  }
  return out;
};

export default sequenceListFindings;
